import classnames from 'classnames';
import React from 'react';
import { HTMLProps } from 'react';

const CSS = require('./Strong.module.scss');

interface StrongProps extends HTMLProps<HTMLDivElement> {
  children: any;
  weight?: 'bold' | 'semi-bold' | 'medium';
  className?: string;
  color?: undefined | 'razzmatazz';
}

function Strong({
  children,
  className,
  weight = 'bold',
  color,
  ...rest
}: StrongProps) {
  const classes = classnames(CSS.Strong, {
    [className]: !!className,
    [CSS.Bold]: weight === 'bold',
    [CSS.SemiBold]: weight === 'semi-bold',
    [CSS.Medium]: weight === 'medium',
    [CSS.Razzmatazz]: color === 'razzmatazz',
  });

  return (
    <strong className={classes} {...rest}>
      {children}
    </strong>
  );
}

export default Strong;
